module.exports = __webpack_public_path__ + "img/text.817a304f.png";